var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    { attrs: { href: _vm.url, target: "_blank", tabindex: "-1" } },
    [
      _c("DefaultWidget", {
        attrs: { name: "转到BiliPlus", icon: "biliplus", disabled: !_vm.url },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }